module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-G-Global-Landing-Page.3c0c5243.jpg";